module.exports = __webpack_public_path__ + "static/award6-afa43b59f2737dc1cc577d6c2d2ae8f4.png";